import { APPSTATE, PMSTATE, USERSSTATE } from '.'
import { ChangesUsers, User } from '../../types'
import { Alerts, PMChatState } from '../../types/state'
import { openMessage } from '../actions/message'
import { AppStateType, UserEvent } from '../constants/enums'
import { idToSlug } from './internal/users'
import { pubSubUsers } from './pubSub'
import { updateAppState } from './state.app'

export function onChanges({ users }: { users: Array<ChangesUsers> }) {
    const alerts: Alerts = {}

    users.forEach((update) => {
        resolveUpdate(update)
        pubSubUsers.emit(UserEvent.UPDATE + '::' + update.id)
        pubSubUsers.emit(
            UserEvent.UPDATE + '::' + update.id + '::' + update.key,
        )
    })

    if (Object.keys(alerts).length) {
        updateAppState(AppStateType.ALERTS, { ...APPSTATE.alerts, ...alerts })
    }
}

function resolveUpdate<K extends keyof User>({
    delete: deleteKey,
    value,
    key,
    id,
}: {
    delete?: boolean
    value?: User[K]
    id: number
    key: K
}) {
    if (deleteKey) {
        //
        // Marc: If you change this behavior to allow deleted keys to emit
        // updates in the "pubSubUsers.emit(`UPDATE:${key}`)" call below, you
        // will impact the subscribe/unsubscribe functionality in
        // "./app-state/state.room.ts". Deleting a key is only possible through
        // the "deleteKeys" option "updateFCSState" update in the worker.
        // Setting a value to "undefined" will not do the trick, as it shouldn't
        // for a number of reasons.
        //
        // The worker also sends deletes for users this client was never sent
        // (the MYL cleanup reaches every model it marked), so there may be
        // no record to delete from.
        //
        delete USERSSTATE.users?.[id]?.[key]
        return
    }

    if (!USERSSTATE.users[id]) {
        USERSSTATE.users[id] = { id }
    }

    const slug = idToSlug[id]

    if (!slug) {
        console.warn('!! COULD NOT INDEX SLUG FOR:', id)
    }

    if (key === 'slug') {
        const previousSlug = USERSSTATE.users[id].slug
        const slug = value
        if (previousSlug && slug && previousSlug !== slug) {
            onModelNameChange({ id, slug })
        }
    }

    pubSubUsers.emit(`UPDATE:${key}`, {
        previous: USERSSTATE.users[id][key],
        current: value,
        id,
    })

    USERSSTATE.users[id][key] = value
}

function onModelNameChange(payload: { id: number; slug: string }) {
    const { slug, id } = payload
    const { [id]: existingState = {} as PMChatState } = PMSTATE.chats
    const { isOpen } = existingState

    if (isOpen) {
        openMessage(slug)
    }
}
